<template>
  <!-- 活动规则弹窗 -->
  <div class="rule" v-show="show_rule">
    <div class="mask" @touchmove.prevent></div>

    <div
      class="container"
      :class="{
        container_scale: show_rule,
        container_scale_ipad: show_rule && is_ipad,
      }"
    >
      <div class="content">
        <div class="rule_title">活动规则</div>
        <div class="rule_list">
          <div class="rule_item">
            <div class="rule_subtitle">【活动时间】</div>
            <div class="rule_tips">1、预约期：截止至2020年11月6日 11:29:59</div>
            <div class="rule_tips">
              2、抢购期：2020年11月6日11:30:00-2020年11月22日 23:59:59
            </div>
            <div class="rule_tips">
              3、领取期：自开通日起至2020年11月30日23:59:59
            </div>
          </div>
          <div class="rule_item">
            <div class="rule_subtitle">【详细规则】</div>
            <div class="rule_tips">
              1、在活动期内开通会员季卡，即可享有快看漫画与其他{{plat_icons.length}}家赠送会员权益：腾讯视频VIP1个月（31天）、QQ音乐豪华绿钻（31天）、优酷VIP1个月（31天）、酷狗豪华VIP1个月（31天）、网易云音乐黑胶VIP会员（31天）、蜻蜓FM超级会员（31天）、百度网盘超级会员1个月（自然月）、懒人听书VIP会员1个月（31天）、肯德基付费会员（30天）<span
                v-show="plat_icons.length == 10"
                >，另外QQ超级会员（31天）为额外赠送会员，数量有限，送完为止</span
              >；
            </div>
            <div class="rule_tips">
              2、每位用户限开通4次，手机号、微信、QQ、设备、支付账号等任意信息一致，即视为同一个用户;
            </div>
            <div class="rule_tips">
              3、会员数量有限，先到先得，售完为止，以购买时实际赠送会员为准;
            </div>
            <div class="rule_tips">
              4、开通成功后，快看漫画会员时长会自动充值到登录的快看账号中，其他赠送会员权益可在11月30日
              23:59:59前自行领取，领取入口【本活动页面】【我的-快看VIP】【我的消息-通知】，逾期视为自动放弃未领取权益;
            </div>
            <div class="rule_tips">
              5、开通领取成功后会员有效期即时生效，如遇网络延迟，请稍后查看到账情况，原有会员用户，开通成功后会员时长在原剩余有效时长基础上延长，如遇总时长限制，以该应用具体限制为准;
            </div>
            <div class="rule_tips">
              6.活动领取手机号仅限变更1次，变更成功后，同步变更活动内所有未领取会员的领取手机号，不可再次变更;
            </div>
            <div class="rule_tips">
              7、活动赠送会员由各联合服务商提供，请在开通会员前仔细阅读会员服务协议，如违反，平台有权按其会员服务协议的规定进行处理
              <div
                v-for="(item, index) in rule_links"
                :key="index"
                @click="jumpToGetPage(item)"
                v-show="
                  (plat_icons.length == 9 && item.name != '超级会员服务协议') ||
                  plat_icons.length == 10
                "
              >
                《{{ item.name }}》
              </div>
            </div>
          </div>
          <div class="rule_item">
            <div class="rule_subtitle">【注意事项】</div>
            <div class="rule_tips">
              1、如若活动期内产生异常情况，快看有权随时取消、暂停本活动;
            </div>
            <div class="rule_tips">
              2、本活动最终解释权归快看漫画所有，与设备制作商Apple.Inc.无关;
            </div>
            <div class="rule_tips">
              3、如对活动有任何疑问，请联系快看客服咨询相关事宜，客服联系方式：快看漫画club微信公众号;
            </div>
          </div>
        </div>
      </div>
      <div class="close_btn" @click="close">
        <img src="../img/close-btn.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import { unfix } from "../js/fix_ele";

const { log } = console;
export default {
  data() {
    return {
      rule_links: [
        {
          name: "快看漫画付费会员服务协议",
          link: "http://www.kuaikanmanhua.com/anim/vipAgreement.html",
        },
        {
          name: "腾讯视频会员服务协议",
          link: "https://film.qq.com/weixin/term.html?from=pay.qq.com&type=pc",
        },
        {
          name: "QQ音乐豪华绿钻服务协议",
          link: "https://y.qq.com/msa/462/service_terms_new.html",
        },
        {
          name: "优酷会员服务协议",
          link: "https://acz.youku.com/wow/ykpage/act/vip_agreement",
        },
        {
          name: "酷狗音乐会员服务协议",
          ios_link: "https://m3ws.kugou.com/vip/ios/agreement_new.html",
          android_link: "https://m3ws.kugou.com/vip/v2/agreement_new.html",
        },
        {
          name: "网易云音乐黑胶VIP服务协议",
          link: "https://music.163.com/prime/vip-contract",
        },
        {
          name: "蜻蜓FM超级会员服务协议",
          link:
            "https://sss.qingting.fm/qt-agreement/super-member-20190724.html",
        },
        {
          name: "百度网盘会员服务协议",
          link: "https://pan.baidu.com/disk/vipduty",
        },
        {
          name: "懒人听书VIP会员服务协议",
          link: "https://m.lrts.me/h5/help/11?style=notitle,nopadding",
        },
        {
          name: "肯德基付费会员服务协议",
          link: "",
        },
        {
          name: "超级会员服务协议",
          link: "",
        },
      ],
    };
  },
  computed: {
    ...mapState(["show_rule", "is_ipad", "plat_icons"]),
  },
  methods: {
    ...mapMutations(["SET_SHOW_RULE"]),
    close() {
      let fixele = document.querySelector(".home");
      unfix(fixele);

      this.SET_SHOW_RULE(false);
    },
    // 是否在小程序中
    isMiniProgram() {
      let is_mini = {
        wechatmini: window.__gvalkkmh.ua.wechatmini,
        qqmini: window.__gvalkkmh.ua.qqmini,
        baidumini: window.__gvalkkmh.ua.baidumini,
      };
      return is_mini;
    },
    // 跳转领取页面
    jumpToGetPage(item) {
      let topage;

      if (/酷狗/.test(item.name)) {
        this.$kkmh.ua().iphone
          ? (topage = item.ios_link)
          : (topage = item.android_link);
      } else {
        topage = item.link;
      }

      if (topage == "") {
        return false;
      }

      if (this.$kkmh.ua().kkmh) {
        this.$kkmh.requestHybrid({
          tagname: "forward",
          param: {
            totype: "h5",
            topage: topage,
            todata: {},
          },
          callback(res) {
            cb && cb(res);
          },
        });
      } else if (
        this.isMiniProgram()["wechatmini"] ||
        this.isMiniProgram()["qqmini"] ||
        this.isMiniProgram()["baidumini"]
      ) {
        location.href = topage;
      } else {
        location.href = topage;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";
.rule {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
}
.container {
  @include boxsize(610, 857);
  @include vhcenter(610,857);
  background-color: #fff;
  border-radius: trans(20);
  position: absolute;
  // top: 11%;
  transform: scale(0);
}
.content {
  @include boxsize(534, 857);
  margin: 0 auto;
  overflow-y: scroll;
  .rule_title {
    @include fontstyle(#422222, 34);
    font-weight: bold;
    text-align: center;
    margin-top: trans(41);
  }
}
.container_scale {
  animation: ruleScale 0.2s 0.2s ease-in-out both;
}
@keyframes ruleScale {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.container_scale_ipad {
  animation: ruleScaleIpad 0.2s 0.2s ease-in-out both;
}

@keyframes ruleScaleIpad {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(0.8);
  }
}

.close_btn {
  @include boxsize(58, 58);
  @include hcenter(58);
  bottom: trans(-102);
  position: absolute;
  img {
    width: 100%;
    display: block;
  }
}
.rule_list {
}
.rule_subtitle {
  @include fontstyle(#422222, 26);
  font-weight: bold;
}
.rule_tips {
  @include fontstyle(#422222, 24);
  margin-left: trans(20);
}
.rule_item {
  margin-bottom: trans(20);
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/Rule.vue